import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Slider = ({ items, isListed }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [itemsToShow, setItemsToShow] = useState(5);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width >= 1024) {
        setItemsToShow(5);
      } else if (width >= 768) {
        setItemsToShow(3);
      } else {
        setItemsToShow(1);
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? items.length - itemsToShow : prevIndex - 1
    );
  };

  const nextSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === items.length - itemsToShow ? 0 : prevIndex + 1
    );
  };

  return (
    <div className="relative">
      {/* Navigation Arrows */}
      <div className="flex justify-end gap-2 mb-4">
        <button
          onClick={prevSlide}
          className="p-2 rounded-full flex items-center justify-center"
          disabled={currentIndex === 0}
          style={{
            background: 'var(--button-secondary-bg)',
            border: '1px solid var(--button-secondary-border)',
            color: 'var(--button-secondary-text)',
            opacity: currentIndex === 0 ? 0.5 : 1,
            cursor: currentIndex === 0 ? 'not-allowed' : 'pointer'
          }}
        >
          <svg
            viewBox="0 0 9 12"
            width="12"
            height="12"
            className="rotate-180"
            style={{ fill: 'currentColor' }}
          >
            <path d="M0.839844 10.59L5.41984 6L0.839844 1.41L2.24984 0L8.24984 6L2.24984 12L0.839844 10.59Z"></path>
          </svg>
        </button>
        <button
          onClick={nextSlide}
          className="p-2 rounded-full flex items-center justify-center"
          disabled={items.length <= itemsToShow}
          style={{
            background: 'var(--button-secondary-bg)',
            border: '1px solid var(--button-secondary-border)',
            color: 'var(--button-secondary-text)',
            opacity: items.length <= itemsToShow ? 0.5 : 1,
            cursor: items.length <= itemsToShow ? 'not-allowed' : 'pointer'
          }}
        >
          <svg
            viewBox="0 0 9 12"
            width="12"
            height="12"
            style={{ fill: 'currentColor' }}
          >
            <path d="M0.839844 10.59L5.41984 6L0.839844 1.41L2.24984 0L8.24984 6L2.24984 12L0.839844 10.59Z"></path>
          </svg>
        </button>
      </div>

      {/* Slider Content */}
      <div className="overflow-hidden">
        <div
          className="flex transition-transform duration-300"
          style={{ transform: `translateX(-${currentIndex * (100 / itemsToShow)}%)` }}
        >
          {items.map((pool, index) => (
            <div
              key={index}
              className="flex-shrink-0 px-2"
              style={{ width: `${100 / itemsToShow}%` }}
            >
              <Link
                to={`/buy/?chain=${pool.chainId}&address=${pool.address}`}
                className="block h-full rounded-xl overflow-hidden transition-all hover:scale-105"
                style={{
                  background: 'var(--card-bg)',
                  border: '1px solid transparent',
                  backgroundImage: 'linear-gradient(var(--card-bg), var(--card-bg)), var(--card-border)',
                  backgroundOrigin: 'border-box',
                  backgroundClip: 'padding-box, border-box',
                  boxShadow: 'var(--shadow)'
                }}
              >
                {/* Banner with Chain Logo */}
                <div className="relative h-32 overflow-hidden">
                  <img
                    src={pool.bannerUrl}
                    alt={`${pool.tokenName} banner`}
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute top-2 right-2">
                    <img
                      src={pool.blockchainLogoUrl}
                      alt="Blockchain logo"
                      className="w-8 h-8"
                    />
                  </div>
                </div>

                {/* Token Info */}
                <div className="p-4 relative">
                  <div className="absolute -top-4 left-4">
                    <img
                      src={pool.logoUrl}
                      alt={`${pool.tokenName} logo`}
                      className="w-10 h-10 rounded-full object-cover"
                    />
                  </div>
                  <div className="pt-2">
                    <div className="flex justify-between items-center">
                      <h3 className="font-bold truncate" style={{ color: 'var(--text-primary)' }}>
                        {pool.tokenName}
                      </h3>
                      {isListed && (
                        <div className="rounded-lg px-2 py-1 text-xs font-medium" style={{
                          background: 'var(--section-bg)',
                          color: 'var(--text-secondary)'
                        }}>
                          Listed
                        </div>
                      )}
                    </div>
                    <p className="text-xs mt-1" style={{ color: 'var(--text-secondary)' }}>
                      Created by: {pool.devAddress.slice(0, 4)}...{pool.devAddress.slice(-3)}
                    </p>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Slider;
